<!--视频列表-->
<template>
  <Layer id="video" :layerName="layerName" :visible="visible">
    <div class="dlrLayer-bottom dlrLayer-video">
      <div class="dlrLayer-video-box">
        <div class="dlrLayer-video-top">
          <div class="dlrLayer-video-head">
            <div
              class="dlrLayer-video-head-con"
              :class="{
                scroll: visibleTabsLength > 4,
              }"
            >
              <ul class="dlrLayer-video-tab">
                <li
                  :class="{
                    current: currentTabId === tab.typeId,
                    'fn-hide': !tab.visible,
                  }"
                  @click="loadVideos(tab.typeId)"
                  v-for="tab in tabs"
                  :key="tab.typeId"
                >
                  <span>{{ tab.name }}</span>
                </li>
              </ul>
            </div>
            <div class="dlrLayer-video-head-right">
              <a
                href="javascript:;"
                @click="close"
                class="dlrLayer-video-head-btn"
                ><i class="iconClose"></i
              ></a>
            </div>
          </div>
        </div>
        <div
          ref="video-list-scroll"
          class="dlrLayer-video-scroll"
          v-for="tab in tabs"
          :key="tab.typeId"
          v-show="currentTabId === tab.typeId"
          @scroll="saveScrollPosition"
        >
          <div  class="dlrLayer-video-list">
            <VideoListItem
              v-for="item in tab.videos"
              :key="item.id"
              :videoId="item.videoId"
              :videoName="item.name"
              :imageUrl="item.imageUrl"
              :playNum="item.playNum"
              :duration="item.duration"
              @videoOpened="close"
            />
          </div>
          <div
            class="dlrLayer-video-more"
            :class="{ 'fn-hide': !tab.hasMore }"
            @click="loadMoreVideos"
          >
            <p>
              <span>点击加载更多</span>
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="dlrLayer-mask"></div>
  </Layer>
</template>
<script>
import { mapGetters } from 'vuex';
import videoApi from '../../apis/video.api';
import * as layerNames from '../../services/layerName';
import Layer from '../Layer.vue';
import VideoListItem from './VideoListItem';

export default {
  name: 'VideoList',
  components: {
    Layer,
    VideoListItem
  },
  data () {
    return {
      layerName: layerNames.VIDEO_LIST,
      visible: true,
      typeId: 0,
      tabList: [{
        name: '金牌说车',
        typeId: 1,
        pageSize: 4,
        pageIndex: 1,
        videos: [],
        hasMore: true,
        visible: false,
      }],
      scrollPosition: {
        x: 0,
        y: 0
      }
    };
  },
  computed: {
    ...mapGetters({
      baseInfo: 'baseInfo',
      videoNum: 'videoNum',
    }),
    dealerId () {
      return this.baseInfo.dealerId;
    },
    tabs () {
      const self = this;
      this.tabList[0].visible = self.videoNum.gold > 0;
      return this.tabList;
    },
    visibleTabsLength () {
      return this.tabList.filter(o => o.visible);
    },
    currentTabId () {
      if (this.typeId !== 0) {
        return this.typeId;
      }
      let tid = 0;
      const currentTab = this.currentTab;
      if (currentTab) {
        tid = currentTab.typeId;
      }
      return tid;
    },
    currentTab () {
      let currentTabs = [];
      if (this.typeId !== 0) {
        currentTabs = this.tabs.filter(t => t.typeId === this.typeId);
      } else {
        currentTabs = this.tabs.filter(t => t.visible);
      }
      if (currentTabs.length > 0) {
        return currentTabs[0];
      }
      return null;
    }
  },
  activated () {
    this.visible = true;
    this.$nextTick(() => {
      this.$refs['video-list-scroll'].forEach(element => {
        if (element.scrollHeight > 0) {
          element.scrollTop = this.scrollPosition.y;
          element.scrollLeft = this.scrollPosition.x;
        }
      });
    });

  },
  mounted () {
    console.log('videoList---mounted');
  },
  created () {
    this.query();
  },
  methods: {
    close () {
      this.visible = false;
    },
    loadVideos (typeId) {
      this.typeId = typeId;
      this.query();
    },
    loadMoreVideos () {
      this.currentTab.pageIndex += 1;
      this.query();
    },
    queryVideoList () {
      const self = this;
      const currentTab = this.currentTab;
      videoApi.getVideoList({
        dealerId: self.dealerId,
        videoType: currentTab.typeId,
        pageIndex: currentTab.pageIndex,
        pageSize: currentTab.pageSize
      }).then(res => {
        console.log(res);
        if (res.pagecount <= currentTab.pageIndex) {
          currentTab.hasMore = false;
        } else {
          currentTab.hasMore = true;
        }
        if (res.list && res.list.length > 0) {
          let len = currentTab.videos.length;
          currentTab.videos.splice(len, 0, ...res.list);
        }
      }).catch(e => {
        console.error('获取小视频列表错误', e);
      });
    },
    query () {
      if (this.currentTab) {
        if (!this.currentTab.hasMore) {
          return;
        }
        this.queryVideoList();
      }
    },
    saveScrollPosition (event) {
      console.log('scrollPosition', event.target.scrollLeft, event.target.scrollTop);
      this.scrollPosition = {
        y: event.target.scrollTop,
        x: event.target.scrollLeft
      };
    },
  }
};
</script>
<style lang="scss">
%dlrHeadIcon {
  display: inline-block;
  width: ptrd(44);
  height: ptrd(88);
  background: no-repeat center;
  background-size: ptrd(44);
  vertical-align: top;
}
.dlrLayer-video {
  width: 100%;
  height: 90%;
  background: #fff;
  border-radius: ptrd(20px) ptrd(20px) 0 0;
  &-box {
    height: 100%;
    display: flex;
    flex-direction: column;
  }
  &-top {
    height: ptrd(88);
    flex-shrink: 0;
  }
  &-head {
    position: relative;
    height: ptrd(88);
    line-height: ptrd(88);
    color: #111e36;
    font-weight: bold;
    a {
      color: initial;
    }

    &-con {
      padding: 0 ptrd(100) 0 ptrd(30px);
      text-align: center;
      @extend %ellipsis-basic;
      font-size: ptrd(34);
      position: relative;
      &.scroll {
        &::after {
          display: block;
        }
      }
      &::after {
        display: none;
        position: absolute;
        content: "";
        width: ptrd(30px);
        height: ptrd(66px);
        right: ptrd(90px);
        top: 50%;
        transform: translateY(-50%);
        @include gradient-horizontal(rgba(#fff, 0) 30%, #fff 60%, #f3f1f1);
      }
    }
    &-right {
      position: absolute;
      top: 0;
      bottom: 0;
      font-size: 0;
      right: ptrd(30);
      text-align: right;
    }
    &-btn {
      display: inline-block;
      vertical-align: top;
      margin: 0 ptrd(16);
      font-size: ptrd(28);
      color: #111e36;
      text-align: center;

      &:first-child {
        margin-left: 0;
      }

      &:last-child {
        margin-right: 0;
      }
    }
    .iconClose {
      @extend %dlrHeadIcon;
      background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEIAAABCBAMAAAAReh3bAAAAJ1BMVEUAAAASHjZmboAVIjdnboMSHjdnbYARHzcSHTVnboARHjYRHjZmbX83wfOTAAAAC3RSTlMAqqolJZ+flLaU2zpA6tgAAADsSURBVEjH3dUhjgIxFAbg7ibLZleBxnAAHBKLRHAEjsA9MFyFIOsIsodiMiEP8XVaz1Pzmr9fk85kXvq02vTWf/OhGvjJp9fTNl+riWW+RSLPk/WV8y20EZF4n74cEYlrvXFbdBK0U0T0ECxAiLIDhA0i5EGIi5AWkQCBAIEAgQCBEIEAgQBZjEQLyRAgECAD0axzN/HfOaWP7OJiJ2pWLql9Y+vyaCPfZUgEUifKMQVSJ+7xiqeIFV+hBAgECAQIBAgECAQIBAgECAQIhIiEiITIbCDaf/59EEyPSNw7E+ivHDtTLO0mJ+GH1RO5wr2RgvOt+wAAAABJRU5ErkJggg==);
    }
  }
  &-tab {
    display: flex;
    align-items: center;
    height: ptrd(88);
    width: 100%;
    overflow-x: auto;
    overflow-y: hidden;
    li {
      // flex: 1;
      // width: 1%;
      position: relative;
      cursor: pointer;
      padding: 0 ptrd(20px);
      font-size: ptrd(32px);
      transition: all 0.2s;
      &::after {
        content: "";
        position: absolute;
        bottom: 0;
        left: 100%;
        width: 50%;
        height: ptrd(8px);
        background: #05f;
        z-index: 1;
        opacity: 0;
        margin-left: ptrd(-15px);
      }
      &.current {
        font-size: ptrd(40px);
        font-weight: bold;
        &::after {
          left: 50%;
          width: ptrd(30px);
          opacity: 1;
          -webkit-transition: 0.4s;
          transition: 0.4s;
        }
        & ~ li::after {
          left: 0;
        }
      }
    }
  }
  &-scroll {
    flex: 1;
    height: 100%;
    @extend %scrolling-touch;
    overflow-x: hidden;
    overflow-y: auto;
  }
  &-list {
  }
  &-item {
    padding: ptrd(32px) 0;
    margin: 0 ptrd(32px);
    border-bottom: 1px solid #f8f9fc;
  }
  &-show {
    position: relative;
    width: 100%;
    height: 0;
    padding-bottom: 56.25%;
    background-color: #020505;
    border-radius: ptrd(8px);
  }
  &-post {
    position: absolute;
    width: 100%;
    height: 100%;
    overflow: hidden;
    border-radius: ptrd(8px);
    img {
      width: 100%;
      height: 100%;
    }
  }
  &-trigger {
    position: absolute;
    width: ptrd(100px);
    height: ptrd(100px);
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    background: url(data:image/png;base64,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)
      no-repeat center center;
    background-size: 100%;
  }
  &-tips {
    position: absolute;
    bottom: 0;
    width: 100%;
    height: ptrd(36px);
    left: 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: ptrd(24px);
    color: #fff;
    @include gradient-vertical(rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.8));
    padding: ptrd(24px);
    box-sizing: border-box;
    p {
      @extend %font-number;
    }
  }
  &-info {
    display: flex;
    align-items: center;
    margin-top: ptrd(20px);
  }
  &-tit {
    flex: 1;
    width: 1%;
    @include fn-ellipsis(2);
    font-size: ptrd(32px);
    line-height: ptrd(44px);
    color: #111e36;
  }
  &-inquiry {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    width: ptrd(128px);
    height: ptrd(64px);
    background-image: linear-gradient(270deg, #206cfe 0%, #4c88ff 100%);
    border-radius: ptrd(8px);
    color: #fff;
    font-size: ptrd(24px);
  }
  &-more {
    font-size: ptrd(28px);
    line-height: ptrd(44px);
    color: #111e36;
    cursor: pointer;
    text-align: center;
    padding: ptrd(16px) 0;
  }
}
</style>
